// extracted by mini-css-extract-plugin
module.exports = {"infoText":"_3083439","content":"_790b070","root":"_3f55257","info":"_53f906f"};